import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';
import { MainContainer, SuggestLabel } from 'components/SearchableDropdown/styles';
import { ListItemContent } from 'components/ListEditor/styles';
import { InputContainer } from 'components/InputIcon/styles';

export interface IRootProps {
  backgroundColorValue?: string;
  maxWidthValue?: string;
}

export const GeneralContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  ${MainContainer} {
      height: unset;
  }
  ${ListItemContent} {
      padding: 0;
  }
  ${InputContainer} {
      box-shadow: none;
  }
`

export const HelpText = styled.div`
  margin-bottom: 15px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #112240;
`

export const AlertContainer = styled.div`
  display:flex;
`

export const AlertContent = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0 ${SIZE.HALF}px;
`

export const AlertTitle = styled.div`
  margin: 0 0;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  padding: ${SIZE.HALF}px 0 ${SIZE.HALF}px 0;
`

export const AlertSubtext = styled.div`
  padding: ${SIZE.HALF}px 0 ${SIZE.HALF}px 0;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #bdbdbd;
`

export const Title = styled.div`
  display: flex;
  flex-flow: row;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;    
  text-align: left;
  color: #000000;    
  margin-bottom: ${SIZE.FIVE}px;
`

export const IconContainer = styled.div`    
  display: flex;     
  justify-content: center;
  width:35px;   
`

export const InputTextarea = styled.textarea`
  display: flex;
  flex: 1;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  outline: none;
  border:none;
  min-height: ${SIZE.FIFTEEN}px; 
  color: #3D3D3D;
`

export const ViewLabel = styled.span`
  display:flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  color: #3D3D3D;
`

export const UrlSectionContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding: ${SIZE.ONE}px;
`

export const Input = styled.input`
  display: flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  color: #343434;
  outline: none;
  border: none;
  padding: ${SIZE.ONE}px 0;
  flex:1;
`

export const DisclaimerLabel = styled(Label)`
  display:flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow:hidden;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  padding: ${SIZE.HALF}px 0 ;
  color: rgba(112, 112, 112, 0.5);
`

export const DateFieldWrapper = styled.div`
  display:flex;
  padding: ${SIZE.ONE}px;
`

//View Keywords

export const ViewKeywordContainer = styled.div`
  display:flex;
  flex-flow: column;
`

export const ViewKeywordSection = styled.div`
  display:flex;
  flex-flow: column;
  margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px;
`

export const ViewKeywordSubtitle = styled.div`
  display:flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 12px;
  text-align: left;
  color: #000;
  margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px 0;
`

export const ViewKeywordList = styled(LIST)`
  display:flex;
  margin: 0;
`

export const ViewKeywordTitle = styled.div`
  display: flex;
  margin-bottom: 14px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #bdbdbd;
`

export const ViewKeywordLabel = styled(Label)`
  display: flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  padding: 0 0 ${SIZE.HALF}px 0 ;
  color: #000;
  margin-bottom: 12px;
`

export const ViewKeywordLabelEdit = styled(Label)`
  display: flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  color: #000;
`

export const ViewKeywordLabelDescription = styled.div`
  width: 50%;
  margin-right: 15px;
`

export const ViewKeywordLabelStatus = styled.div`
  width: 50%;
`

export const ShowAllButton = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4da0ff;
  cursor: pointer;
  text-decoration: underline;
`

// Hoverable Suggestions
export const Message = styled.div`
  position:relative;
  display: flex;
  height: ${SIZE.TWO}px;
  margin: 0 0 ${SIZE.THREE}px 0;
  padding: ${SIZE.ONE}px 0px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  color: #bdbdbd;
`

//Edit Keywords
export const EditKeywordsContainer = styled.div`
`

export const EditSHRowsContainer = styled.div`
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const EditSHEmptyState = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #bdbdbd;
`

export const MaximumKeywordsLabel = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9c9c9c;
`

export const EditKDividerContainer = styled.div`
  position: relative;
`

export const EditKDivider = styled.div`
  position: absolute;
  width: calc(100% + 30px);
  top: 0px;
  right: 0px;
  height: 1px;
  background-color: #bdbdbd;
`

export const EditKRowBigContainer = styled.div`
  width: 100%;
`

export const EditKRowTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const EditKRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 22px;
  padding-bottom: 22px;
`

export const EditKRowTitle = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
`

export const EditKInput = styled.input`
  max-width: ${(props: IRootProps) => (props.maxWidthValue ?? 'auto')};
  height: 30px;
  border-radius: 5px;
  border: solid 1px #dadada;
  background-color: ${(props: IRootProps) => (props.backgroundColorValue ?? '#fff')};
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  box-sizing: border-box;
  padding: 0px 10px 0px 10px;
  color: #122442;
`

export const EditKRowKeywords = styled.div`
  box-sizing: border-box;
  width: 50%;
  padding-right: 10px;
`

export const EditKDateFields = styled.div`
  display: flex;
`

export const EditKRowLocationsName = styled.div`
  width: 50%;
`

export const EditKRowLocationsNameDetail = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EditKHoursFields = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EditKActionsContainer = styled.div`
  display: flex;
  cursor: pointer;
`

export const EditKActionEdit = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  transform: scale(0.6);
`

export const EditKActionClose = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px; 
`

export const EditKActionAdd = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 30px;
  border-radius: 5px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  text-align: left;
  color: #4da0ff;
  box-sizing: border-box;
  &:hover {
    border: solid 1px #4da0ff;
  }
`

export const KeywordChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
`

export const KeywordChipContainer = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 20px;
  border: solid 2px #ebecf0;
  background-color: #fff;
  padding: 2px 6px 2px 14px;
  margin: 0px 5px 9px 0px;
`

export const KeywordChipLabel = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #a5a5a5;
  word-break: break-word;
`

export const KeywordChipRemoveIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
` 
